import axios from 'axios';
const instance = axios.create({
    headers: {"X-Spree-Token": process.env.SPREE_API_KEY,
        "Content-Type":"application/json"}
});

export default instance;